export type ProcessParametersParseResult =
  | { ok: true; parameters: Record<string, unknown> }
  | { ok: false; error: string };

export function parseProcessParametersJson(json: string): ProcessParametersParseResult {
  try {
    const parsed: unknown = JSON.parse(json);
    if (!parsed || Array.isArray(parsed) || typeof parsed !== 'object') {
      throw new Error();
    }
    return { ok: true, parameters: parsed as Record<string, unknown> };
  } catch {
    return { ok: false, error: 'Process parameters must be a valid JSON object' };
  }
}

export function editableParametersJson(value?: string | null): string {
  if (value == null || !value.trim()) {
    return '{}';
  }
  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch {
    return value;
  }
}
